import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const KEY = "rawaj_wa_alerts";
export const alertsEnabled = () => localStorage.getItem(KEY) !== "off";
export const setAlertsEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

export const beep = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.18].forEach((t, i) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = i ? 1180 : 880;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t); g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.16);
      o.connect(g).connect(ctx.destination); o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.2);
    });
    setTimeout(() => ctx.close(), 600);
  } catch { /* no audio */ }
};

export const requestNotifyPermission = async () => {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "default") return Notification.requestPermission();
  return Notification.permission;
};

const notify = (title, body, onClick) => {
  if ("Notification" in window && Notification.permission === "granted" && document.visibilityState !== "visible") {
    try { const n = new Notification(title, { body, icon: "/icon-192.png", tag: "rawaj-wa", renotify: true }); n.onclick = () => { window.focus(); onClick?.(); n.close(); }; } catch { /* ignore */ }
  }
};

// يستطلع /wa-bot/alerts كل 20 ث ويطلق صوتًا + إشعار متصفح + toast عند رسالة أو تصعيد جديد
export const WaAlerts = () => {
  const nav = useNavigate();
  const prev = useRef(null);
  useEffect(() => {
    let stop = false;
    const tick = async () => {
      if (!alertsEnabled() || !localStorage.getItem("rawaj_token")) return;
      try {
        const d = (await api.get("/wa-bot/alerts")).data;
        const p = prev.current;
        prev.current = d;
        if (!p || stop) return;
        const go = (pid, tab) => () => { if (pid) localStorage.setItem("rawaj_active", pid); nav(`/app/whatsapp-bot?tab=${tab}`); };
        if (d.open_escalations > p.open_escalations && d.latest_escalation) {
          const e = d.latest_escalation;
          beep();
          toast.warning(`تصعيد جديد — ${e.bot}`, { description: `${e.name ? e.name + ": " : ""}«${e.question}»`, duration: 12000, action: { label: "أجب الآن", onClick: go(e.project_id, "escalations") } });
          notify(`تصعيد جديد يحتاج ردك — ${e.bot}`, e.question, go(e.project_id, "escalations"));
        } else if (d.unread > p.unread || (d.last_inbound_at && d.last_inbound_at !== p.last_inbound_at)) {
          const l = d.latest || {};
          beep();
          toast(`رسالة جديدة — ${l.bot || "واتساب"}`, { description: `${l.name || "+" + l.wa_id}: ${l.last_text || ""}`, duration: 8000, action: { label: "افتح", onClick: go(l.project_id, "inbox") } });
          notify(`${l.name || "+" + l.wa_id} — ${l.bot || "واتساب"}`, l.last_text || "رسالة جديدة", go(l.project_id, "inbox"));
        }
      } catch { /* silent */ }
    };
    tick();
    const t = setInterval(tick, 20000);
    return () => { stop = true; clearInterval(t); };
  }, [nav]);
  return null;
};
